<template>
  <div class="flex p-4 w-full justify-between">
    <div class="flex items-center truncate">
      <ThemeImage
        :icon="imageNames.LINKEDIN"
        alt="linkedin"
        class="w-5 h-5"
      />
      <span class="ml-2.5">{{ displayText }}</span>
    </div>
    <div class="flex items-center">
      <div v-if="isPrimary" class="action_button">Primary</div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";

const props = defineProps(["value", "row"]);

// Handle both object and string formats for backward compatibility
const displayText = computed(() => {
  if (typeof props.value === 'string') {
    return props.value;
  }
  return props.value?.text || 'LinkedIn Account';
});

const isPrimary = computed(() => {
  if (typeof props.value === 'string') {
    return props.row?.is_default || false;
  }
  return props.value?.is_default || false;
});
</script>
